function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20 40C8.981 40 0 31.019 0 20S8.981 0 20 0s20 8.981 20 20-8.981 20-20 20zm0-37.736C10.226 2.264 2.264 10.226 2.264 20c0 9.774 7.962 17.736 17.736 17.736 9.774 0 17.736-7.962 17.736-17.736 0-9.774-7.962-17.736-17.736-17.736z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.49 26.793H11.51a1.113 1.113 0 01-1.133-1.133c0-.641.491-1.132 1.132-1.132h16.982c.641 0 1.132.49 1.132 1.132 0 .642-.49 1.133-1.132 1.133zm0-11.321H11.51c-.642 0-1.133-.49-1.133-1.132 0-.642.491-1.133 1.132-1.133h16.982c.641 0 1.132.491 1.132 1.133 0 .641-.49 1.132-1.132 1.132zm0 5.66H11.51c-.642 0-1.133-.49-1.133-1.132 0-.642.491-1.132 1.132-1.132h16.982c.641 0 1.132.49 1.132 1.132 0 .642-.49 1.132-1.132 1.132z",
  fill: "#fff"
});

var SvgIconMenu = function SvgIconMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "assets/icon_menu.51156b72.svg";
export { SvgIconMenu as ReactComponent };